<!-- 
                <div style="height:300px;width:95%;">
                <form 
                (ngSubmit)="onSubmitFindInvoice()" 
                novalidate
                [formGroup]="inoviceSearchForm" style="margin-top:20px;">
                    <div class="row margin-top:20px;">
                        <div class="col-3">
                            <mat-form-field appearance="fill" style="width:100%;">
                                <mat-label class="font-size-normal">Invoice Number</mat-label>
                                <input matInput placeholder="Invoice Number" autocomplete="chrome-off" formControlName="invoiceNumber" class="font-size-normal" >
                                <mat-error *ngIf="inoviceSearchForm.get('invoiceNumber')!.hasError('required')" class="font-size-normal">The Invoice Number is required</mat-error>
                                <mat-error *ngIf="inoviceSearchForm.get('invoiceNumber')!.hasError('maxlength')" class="font-size-normal">The maximum length cannot exceed 32 characters</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <button type="submit" class="btn btn-primary mt-3" style="margin-left:0px;" [disabled]="!inoviceSearchForm.valid">Find Invoice</button>
                        </div>
                    </div>
                </form>
           
                <ng-container *ngIf="invoiceNumberFound ===''">
                    
                </ng-container>

                <ng-container *ngIf="invoiceNumberFound !==''">
                    <mat-card>
                        <div style="margin-top:20px;margin-left:20px;">
                            <span>Invoice Found for Lot 3250 - City Center Bellevue </span>
                        </div>
                        <div class="row" style="margin-top:20px;margin-left:20px;margin-bottom:30px;">
                            <div class="col-4">
                                
                               
                                <span class="material-icons mimic-button-hover" style="color:#002F87;margin-left:10px;position:relative;top:7px;" (click)="onNavToViewInvoice()">
                                    monetization_on
                                </span>
                                <span style="color:black;margin-left:5px;color:#002F87" class="mimic-button-hover" (click)="onNavToViewInvoice()">View Invoice</span>
                            </div>
                            <div class="col-4">
                                
                                
                                <span class="material-icons mimic-button-hover" style="color:#002F87;position:relative;top:7px;" (click)="onNavEnableScreen()">
                                    summarize
                                </span>
                                <span style="color:black;margin-left:5px;" class="mimic-button-hover" (click)="onNavEnableScreen()">Enable Screen</span>
                            </div>
                        </div>
                    </mat-card>
                    
                </ng-container>
            </div>
            
            -->

        
<div class="breadcrumb-dev">
    <button mat-icon-button class="mt-0 ml-2" 
    style="margin-left:20px;width:300px;"
    >
    <mat-icon style="margin-left:2px;color:black;" >arrow_back</mat-icon>
    Return to Invoice List
    </button>
    
    
        <div 
            *ngIf="this.turnOnSpinner === true"
                mode="indeterminate"
                style="width:100px;height:100px;margin:0 auto;"
            >
            <div class="spinner-wrapper">
                <mat-spinner></mat-spinner>
            </div>
    
        </div>
    <div style="height:2000px;">
    <mat-tab-group class="ml-4 mr-4" style="margin-left:20px;margin-right:20px;margin-top:20px;height:2000px;">
    
        <mat-tab style="height:2000px;">
            <ng-template mat-tab-label>
                <strong>Payments / Refunds</strong>
            </ng-template>
    
            <!-- Add Payments to Existing Invoices -->
            <app-payment [invoiceNumber]=currentInvoiceNumber></app-payment>
        
        </mat-tab>
    
        <mat-tab  style="height:1500px;">
            <ng-template mat-tab-label>
                <strong>Adjustments</strong>
            </ng-template>
    
            <!-- Adjust Existing Invoice Line Item Balances -->
            <app-adjust-billing  [invoiceNumber]=currentInvoiceNumber></app-adjust-billing>
            
        </mat-tab>
    
        <mat-tab style="height:2000px;">
            <ng-template mat-tab-label>
                <strong>Add Revenue</strong>
            </ng-template>
    
            <!-- Add Revenue to Existing Invoices -->
            <app-add-revenue  [invoiceNumber]=currentInvoiceNumber></app-add-revenue>
    
        </mat-tab>
    
    </mat-tab-group>
    </div>
    